/**
 * Constantes relacionadas à autenticação e gerenciamento de sessão
 */

/** Nome do cookie que armazena o ID da sessão do tenant */
export const COOKIE_SESSION_ID = "sessionId";

/** Timeout em milissegundos para requisições de logout (5 segundos) */
export const LOGOUT_TIMEOUT_MS = 5000;

/** Número máximo de tentativas de retry para logout */
export const LOGOUT_MAX_RETRIES = 2;

/** Chave do localStorage para estado de autenticação (deprecated) */
export const AUTH_STORAGE_KEY = "isLogged";
